import { useQuery } from "@tanstack/react-query";

import { $api } from "../../global";
import { proConst } from "..";

export const useProPrice = () => {
  const { data, ...args } = useQuery({
    queryKey: [proConst.queryKeys.PRO_PRICE],
    queryFn: async () => {
      const { data } = await $api.get<number>('/get-premium-price');

      return { proPrice: data };
    }
  });

  return { ...data, ...args };
};
